import { Col, DatePicker, Form, Input, message, Row } from "antd";
import React from "react";

function PrescriptionFilter(props) {
  const [form] = Form.useForm();

  const onFinish = (e) => {
    let values = form.getFieldValue();
    if (
      !values.fromDate &&
      !values.toDate &&
      !values.userName &&
      !values.clinic_Name &&
      !values.appointmentId
    ) {
      message.warning("Please enter at least one filter value!");
      return;
    }
    props.onClose(values);
  };
  const handleCancel = () => {
    props.onClose();
  };
  return (
    <div>
      <Form
        name="basic"
        labelCol={{
          span: 24,
        }}
        wrapperCol={{
          span: 24,
        }}
        form={form}
        onFinish={onFinish}
      >
        <div className="border rounded-lg p-2">
          <Row gutter={[16, 0]}>
            <Col xs={24} sm={24} md={12}>
              <Form.Item className="mb-0" label="Doctor Name" name="userName">
                <Input placeholder="Enter First Name" className="w-full h-8" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12}>
              <Form.Item
                className="mb-0"
                label="Clinic Name"
                name="clinic_Name"
              >
                <Input placeholder="Enter" className="w-full h-8" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12}>
              <Form.Item
                className="mb-0"
                label="Appointment Id"
                name="appointmentId"
              >
                <Input placeholder="Enter" className="w-full h-8" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12}>
              <Form.Item className="mb-0" label="From Date" name="fromDate">
                <DatePicker
                  placeholder="Date"
                  className="w-full h-8"
                  placement="bottomLeft"
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12}>
              <Form.Item className="mb-0" label="To Date" name="toDate">
                <DatePicker
                  placeholder="Date"
                  className="w-full h-8"
                  placement="bottomLeft"
                />
              </Form.Item>
            </Col>

            <Col span={24}>
              <div className="flex justify-end gap-3 mt-5">
                <button
                  onClick={handleCancel}
                  className="bg-White text-brand-primaryColor border-primaryColor border rounded-lg w-[100px] h-[40px] text-base"
                >
                  Cancel
                </button>
                <button className="bg-primaryColor w-[100px] h-[40px] text-base rounded-lg text-white">
                  Filter
                </button>
              </div>
            </Col>
          </Row>
        </div>
      </Form>
    </div>
  );
}

export default PrescriptionFilter;
